import {
  databases,
  APPWRITE_DB_ID,
  APPWRITE_BLOGS_COLLECTION_ID,
} from "../AppWrite/appwrite";
import { Query, ID } from "appwrite";

export const fetchGetAllBlogs = async () => {
  try {
    let allBlogs = [];

    const response = await databases.listDocuments(
      APPWRITE_DB_ID,
      APPWRITE_BLOGS_COLLECTION_ID,
      [(Query.orderDesc("$createdAt"), Query.limit(100))]
    );

    allBlogs = [...allBlogs, ...response.documents];
    return { success: true, blogs: allBlogs };
  } catch (e) {
    console.error("Error fetching blogs:", e);
    return { success: false, message: "Failed to fetch blogs" };
  }
};

export const fetchWriteBlog = async (payload) => {
  try {
    const response = await databases.createDocument(
      APPWRITE_DB_ID,
      APPWRITE_BLOGS_COLLECTION_ID,
      ID.unique(),
      {
        Title: payload.title,
        Preview: payload.preview,

        Description: payload.description,
      }
    );
    return { success: true, data: response };
  } catch (e) {
    console.error("Error posting blogs:", e);
    return { success: false, message: "Failed to post blogs" };
  }
};

export const fetchGetBlogById = async (blogID) => {
  try {
    const response = await databases.getDocument(
      APPWRITE_DB_ID,
      APPWRITE_BLOGS_COLLECTION_ID,
      blogID
    );
    return { success: true, data: response };
  } catch (e) {
    console.error("Error fetching blogs by ID:", e);
    return { success: false, message: "No blogs found!" };
  }
};
